export enum TimeFilterType {
    Unset = 0,
    None = 1,
    Range = 2,
    Daily = 3
}
